"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageVariant = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _Title = _interopRequireDefault(require("../Title"));

var _ContentBox = _interopRequireDefault(require("../ContentBox"));

var _Button = _interopRequireDefault(require("../Button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var PageVariant = function PageVariant(_ref) {
  var title = _ref.title,
      type = _ref.type,
      message = _ref.message,
      actionButtonLabel = _ref.actionButtonLabel,
      primaryButtonLabel = _ref.primaryButtonLabel,
      onActionButtonClick = _ref.onActionButtonClick,
      onPrimaryButtonClick = _ref.onPrimaryButtonClick,
      primaryButtonProps = _ref.primaryButtonProps,
      children = _ref.children;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "PageVariant wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "main"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "justify-content-center"
  }, /*#__PURE__*/_react.default.createElement(_ContentBox.default, {
    underline: false,
    className: type
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    type: type,
    size: 32
  }), /*#__PURE__*/_react.default.createElement(_Title.default, {
    type: 2
  }, title), /*#__PURE__*/_react.default.createElement("p", null, message), /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: "secondary",
    text: actionButtonLabel,
    onClick: onActionButtonClick
  }, actionButtonLabel), primaryButtonLabel && /*#__PURE__*/_react.default.createElement(_Button.default, _extends({
    type: "primary",
    text: primaryButtonLabel,
    onClick: onPrimaryButtonClick
  }, primaryButtonProps), primaryButtonLabel), children))));
};

exports.PageVariant = PageVariant;
PageVariant.propTypes = {
  /** Title of Error */
  title: _propTypes.default.string.isRequired,

  /** Type of page */
  type: _propTypes.default.string.isRequired,

  /** Message error */
  message: _propTypes.default.string.isRequired,

  /** The content below buttons */
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.string]),

  /** Label for Action button */
  actionButtonLabel: _propTypes.default.string.isRequired,

  /** Label for Action button */
  onActionButtonClick: _propTypes.default.func.isRequired,

  /** Label for Primary button */
  primaryButtonLabel: _propTypes.default.string,

  /** Additional props for Primary button */
  primaryButtonProps: _propTypes.default.shape(_defineProperty({}, _propTypes.default.string, _propTypes.default.any)),

  /** Click action for Primary button */
  onPrimaryButtonClick: _propTypes.default.func
};
PageVariant.defaultProps = {
  children: null,
  primaryButtonLabel: null,
  primaryButtonProps: {},
  onPrimaryButtonClick: function onPrimaryButtonClick() {}
};